<template>
  <v-card-text class="pb-3">
    <v-container class="pa-0">
      <v-carousel
        v-model="carousel"
        height="240"
        cycle
        hide-delimiters
        :show-arrows="false"
        class="h-carousel mb-4"
        interval="5000"
      >
        <v-carousel-item
          v-for="n in length"
          :key="n"
          :src="`./i/welcome${n}.png`"
        />
      </v-carousel>
      <v-row
        no-gutters
        align="center"
        style="min-height: 100px;"
      >
        <v-col cols="2">
          <v-btn
            icon
            small
            @click="prev()"
          >
            <v-icon v-text="icons.prev" />
          </v-btn>
        </v-col>
        <v-col cols="8" class="text-h6 text-center">
          <v-window v-model="carousel">
            <v-window-item
              v-for="n in length"
              :key="n"
              v-text="__(`welcome${n}`)"
            />
          </v-window>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            icon
            small
            @click="next()"
          >
            <v-icon v-text="icons.next" />
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <v-item-group
            v-model="carousel"
            mandatory
          >
            <v-item
              v-for="i in length"
              :key="i"
              v-slot="{ active, toggle }"
              active-class="primary--text"
            >
              <v-btn
                :input-value="active"
                icon
                x-small
                @click="toggle"
              >
                <v-icon small v-text="icons.dot" />
              </v-btn>
            </v-item>
          </v-item-group>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-btn
            block
            depressed
            color="primary"
            class="mt-2"
            @click="$emit('goto', 'demo')"
            v-text="__('freeTrial')"
          />
        </v-col>
        <v-col cols="12" class="text-center text-caption">
          {{ __('trialDays') }}
        </v-col>
        <v-col cols="6" class="h-welcome-link">
          <a @click="$store.dispatch('purchase/open')" class="accent--text">{{ __('activateAccount') }}</a>
        </v-col>
        <v-col cols="6" class="h-welcome-link">
          <a @click="$emit('goto', 'form')" class="accent--text">{{ __('haveAccount') }}</a>
        </v-col>
      </v-row>
    </v-container>
    <h-purchase />
  </v-card-text>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HPurchase from '@/Sections/Purchase/Dialog'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HPurchase,
    },

    data: () => ({
      length: 5,
      carousel: 0,
    }),

    methods: {
      next () {
        this.carousel = (this.carousel + 1 === this.length)
          ? 0
          : this.carousel + 1
      },
      prev () {
        this.carousel = (this.carousel - 1 < 0)
          ? this.length - 1
          : this.carousel - 1
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-carousel {
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
  }
  .h-welcome-link {
    text-align: center;
    margin-top: 12px;
    line-height: 1.3;
  }
</style>
